/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `Decimal` scalar type to represent currency values */
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** Mongo object id scalar type */
  ObjectId: any;
  /** Time in 24-hour format (HH:mm) */
  Time24: any;
};

export type Advertiser = {
  __typename?: 'Advertiser';
  _id: Scalars['ObjectId'];
  allowContentRecirculationCampaigns?: Maybe<Scalars['Boolean']>;
  allowCpcCpa?: Maybe<Scalars['Boolean']>;
  allowFillerCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: Maybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowPreferredDeals?: Maybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowTeaserRibbon?: Maybe<Scalars['Boolean']>;
  allowTeaserVideos?: Maybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: Maybe<Scalars['Boolean']>;
  allowVevIntegration?: Maybe<Scalars['Boolean']>;
  allowedCurrencies?: Maybe<Array<Currencies>>;
  allowedMarketplaces?: Maybe<Array<Marketplace>>;
  allowedTeaserFormatTypes: Array<TeaserFormatType>;
  allowedTeaserFormats: Array<TeaserFormat>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discounts?: Maybe<Array<CompanyDiscount>>;
  image?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  /** JSON Schema defining valid label configurations for this company */
  labelSchema?: Maybe<Scalars['JSONObject']>;
  labels: Array<Label>;
  marketplace?: Maybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  ownerCompanyId?: Maybe<Scalars['ObjectId']>;
  platformFee?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  targetingSections: Array<Scalars['String']>;
  type: CompanyType;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
};

export type AdvertorialSite = {
  __typename?: 'AdvertorialSite';
  footerCode?: Maybe<Scalars['String']>;
  headerCode?: Maybe<Scalars['String']>;
  hostingType: HostingType;
  logoImageId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
};

export type AdvertorialSiteInput = {
  footerCode?: InputMaybe<Scalars['String']>;
  headerCode?: InputMaybe<Scalars['String']>;
  hostingType?: InputMaybe<HostingType>;
  logoImageId?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  templateName?: InputMaybe<Scalars['String']>;
};

export type Agency = {
  __typename?: 'Agency';
  _id: Scalars['ObjectId'];
  allowContentRecirculationCampaigns?: Maybe<Scalars['Boolean']>;
  allowCpcCpa?: Maybe<Scalars['Boolean']>;
  allowFillerCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: Maybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowPreferredDeals?: Maybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowTeaserRibbon?: Maybe<Scalars['Boolean']>;
  allowTeaserVideos?: Maybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: Maybe<Scalars['Boolean']>;
  allowVevIntegration?: Maybe<Scalars['Boolean']>;
  allowedCurrencies?: Maybe<Array<Currencies>>;
  allowedMarketplaces?: Maybe<Array<Marketplace>>;
  allowedTeaserFormatTypes: Array<TeaserFormatType>;
  allowedTeaserFormats: Array<TeaserFormat>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discounts?: Maybe<Array<CompanyDiscount>>;
  image?: Maybe<Scalars['String']>;
  /** JSON Schema defining valid label configurations for this company */
  labelSchema?: Maybe<Scalars['JSONObject']>;
  labels: Array<Label>;
  marketplace?: Maybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  targetingSections: Array<Scalars['String']>;
  type: CompanyType;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
};

/** Placement allowed campaigns */
export enum AllowedCampaigns {
  AllExceptSensitive = 'ALL_EXCEPT_SENSITIVE',
  RuleBased = 'RULE_BASED'
}

export type AssignmentPlacements = {
  __typename?: 'AssignmentPlacements';
  placementIds: Array<Scalars['String']>;
  publicationId: Scalars['String'];
};

/** Teaser Assignment statuses */
export enum AssignmentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type BidMultipliersFilterArgs = {
  campaignId?: InputMaybe<Scalars['ObjectId']>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
};

export type BulkUpdateTeaserInput = {
  id: Scalars['ObjectId'];
  record: UpdateTeaserInput;
};

export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['ObjectId'];
  actions: Array<CampaignAction>;
  advertiser?: Maybe<Advertiser>;
  advertiserId: Scalars['ObjectId'];
  billingId?: Maybe<Scalars['String']>;
  budgetDeduction?: Maybe<Scalars['Decimal']>;
  comment?: Maybe<Scalars['String']>;
  content?: Maybe<Content>;
  contentSource?: Maybe<CampaignContentSource>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['ObjectId']>;
  dailyBudgetLimit?: Maybe<Scalars['Decimal']>;
  dealId?: Maybe<Scalars['ObjectId']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveredValue?: Maybe<Scalars['Float']>;
  disableSEO?: Maybe<Scalars['Boolean']>;
  ecpmOptimization?: Maybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  epomId?: Maybe<Scalars['Int']>;
  everActivated?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Array<Label>>;
  landingPage?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Marketplace>;
  name: Scalars['String'];
  optimisation?: Maybe<CampaignOptimisationType>;
  ownerCompany?: Maybe<Company>;
  ownerCompanyId: Scalars['ObjectId'];
  pacing?: Maybe<CampaignPacing>;
  policyUrl?: Maybe<Scalars['String']>;
  priority?: Maybe<CampaignPriorityType>;
  publications?: Maybe<Array<Publication>>;
  publisherIds?: Maybe<Array<Scalars['ObjectId']>>;
  publishers: Array<Publisher>;
  rateCard?: Maybe<CampaignRateCard>;
  sensitiveCategory?: Maybe<CampaignSensitiveCategory>;
  sponsor?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status?: Maybe<CampaignStatus>;
  syncStatus?: Maybe<SyncStatus>;
  targetType?: Maybe<CampaignTargetType>;
  targetValue?: Maybe<Scalars['Decimal']>;
  targeting?: Maybe<Targeting>;
  teasers: Array<Teaser>;
  trackingTag?: Maybe<TrackingTag>;
  type?: Maybe<CampaignType>;
  updatedAt: Scalars['DateTime'];
  verifiedReadActionId?: Maybe<Scalars['Int']>;
  verifiedReadActionKey?: Maybe<Scalars['String']>;
  websiteIds?: Maybe<Array<Scalars['ObjectId']>>;
  websites?: Maybe<Array<Website>>;
};

export type CampaignAction = {
  __typename?: 'CampaignAction';
  action: CampaignActionType;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledReason?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
};

/** Campaign action options */
export enum CampaignActionType {
  AcceptAllPublications = 'ACCEPT_ALL_PUBLICATIONS',
  Approve = 'APPROVE',
  Finish = 'FINISH',
  Pause = 'PAUSE',
  Reject = 'REJECT',
  RejectAllPublications = 'REJECT_ALL_PUBLICATIONS',
  Resume = 'RESUME',
  SubmitToAdvertiser = 'SUBMIT_TO_ADVERTISER',
  SubmitToWebsites = 'SUBMIT_TO_WEBSITES',
  ToDraft = 'TO_DRAFT'
}

/** Campaign content source */
export enum CampaignContentSource {
  ContimoContent = 'CONTIMO_CONTENT',
  ProviderContent = 'PROVIDER_CONTENT',
  SelfHostedContent = 'SELF_HOSTED_CONTENT'
}

export type CampaignDeliveryDefaults = {
  __typename?: 'CampaignDeliveryDefaults';
  deliveryTarget?: Maybe<CampaignTargetType>;
  optimisation?: Maybe<CampaignOptimisationType>;
  pacing?: Maybe<CampaignPacing>;
  priceType?: Maybe<CampaignPriceModel>;
  priority?: Maybe<CampaignPriorityType>;
};

export type CampaignDeliveryOptions = {
  __typename?: 'CampaignDeliveryOptions';
  currencies: Array<Currencies>;
  defaults: CampaignDeliveryDefaults;
  deliveryTargets: Array<CampaignTargetType>;
  optimisations: Array<CampaignOptimisationType>;
  pacingOptions: Array<CampaignPacing>;
  priceTypes: Array<CampaignPriceModel>;
  priorities: Array<CampaignPriorityType>;
};

export type CampaignFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  advertiserId?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Show only the campaigns that have publications awaiting approval */
  awaitingApproval?: InputMaybe<Scalars['Boolean']>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  labels?: InputMaybe<Array<Scalars['ObjectId']>>;
  notOwned?: InputMaybe<Scalars['Boolean']>;
  onlyOwned?: InputMaybe<Scalars['Boolean']>;
  /** This filter is available only for super admins. */
  ownerCompanyId?: InputMaybe<Scalars['ObjectId']>;
  /** This filter is available only for super admins. */
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<CampaignStatus>>;
  type?: InputMaybe<Array<CampaignType>>;
  /** Filter campaigns associated with this website ids. */
  websiteIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

/** Campaign optimisation types */
export enum CampaignOptimisationType {
  Clickouts = 'CLICKOUTS',
  Conversions = 'CONVERSIONS',
  Ctr = 'CTR',
  Reads = 'READS'
}

/** Campaign pacing options */
export enum CampaignPacing {
  Asap = 'ASAP',
  Even = 'EVEN'
}

/** Campaign rate card price models */
export enum CampaignPriceModel {
  Cpa = 'CPA',
  Cpc = 'CPC',
  Cpclo = 'CPCLO',
  CpcCpa = 'CPC_CPA',
  Cpm = 'CPM',
  Cpr = 'CPR'
}

/** Campaign's Epom priority type */
export enum CampaignPriorityType {
  HouseAds = 'HOUSE_ADS',
  NonGuaranteed = 'NON_GUARANTEED',
  Premium = 'PREMIUM',
  StandardHigh = 'STANDARD_HIGH',
  StandardLow = 'STANDARD_LOW',
  StandardMedium = 'STANDARD_MEDIUM'
}

export type CampaignRateCard = {
  __typename?: 'CampaignRateCard';
  /** @deprecated Use priceModel instead */
  costPerClickout?: Maybe<Scalars['Decimal']>;
  /** @deprecated Use priceModel instead */
  costPerRead?: Maybe<Scalars['Decimal']>;
  /** @deprecated Use priceModel instead */
  cpm?: Maybe<Scalars['Decimal']>;
  currency?: Maybe<Currencies>;
  price: Scalars['Decimal'];
  priceModel: CampaignPriceModel;
  websitePrices?: Maybe<Array<WebsitePrice>>;
};

export type CampaignRateCardInput = {
  currency?: InputMaybe<Currencies>;
  price: Scalars['Decimal'];
  priceModel: CampaignPriceModel;
  websitePrices?: InputMaybe<Array<WebsitePriceInput>>;
};

/** Campaign sensitive category types */
export enum CampaignSensitiveCategory {
  Adult = 'ADULT',
  Gambling = 'GAMBLING',
  NotSensitive = 'NOT_SENSITIVE',
  Political = 'POLITICAL'
}

/** Campaign status options */
export enum CampaignStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Paused = 'PAUSED',
  Ready = 'READY',
  ReviewingByAdvertiser = 'REVIEWING_BY_ADVERTISER'
}

/** Campaign tag types */
export enum CampaignTagType {
  ImpressionPixel = 'IMPRESSION_PIXEL',
  Pixel = 'PIXEL',
  Script = 'SCRIPT'
}

/** Campaign target types */
export enum CampaignTargetType {
  Budget = 'BUDGET',
  Clickouts = 'CLICKOUTS',
  Cpm = 'CPM',
  Impressions = 'IMPRESSIONS',
  Reads = 'READS'
}

/** Campaign type */
export enum CampaignType {
  ContentRecirculation = 'CONTENT_RECIRCULATION',
  Filler = 'FILLER',
  InHouse = 'IN_HOUSE',
  InHouseNativeDisplay = 'IN_HOUSE_NATIVE_DISPLAY',
  MarketplaceNativeDisplay = 'MARKETPLACE_NATIVE_DISPLAY',
  Standard = 'STANDARD'
}

export type Change = {
  __typename?: 'Change';
  field: Scalars['String'];
  /** The new value of the field */
  new_value?: Maybe<Scalars['JSON']>;
  /** The old value of the field */
  old_value?: Maybe<Scalars['JSON']>;
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  _id: Scalars['ObjectId'];
  changes?: Maybe<Array<Change>>;
  companyId?: Maybe<Scalars['ObjectId']>;
  createdAt: Scalars['DateTime'];
  doc: Scalars['String'];
  docId: Scalars['ObjectId'];
  docOperation: DocOperationType;
  operation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['ObjectId']>;
};

export type ChangeLogFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  doc?: InputMaybe<Scalars['String']>;
  docId?: InputMaybe<Scalars['ObjectId']>;
  docOperation?: InputMaybe<DocOperationType>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ObjectId']>;
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['ObjectId'];
  allowContentRecirculationCampaigns?: Maybe<Scalars['Boolean']>;
  allowCpcCpa?: Maybe<Scalars['Boolean']>;
  allowFillerCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: Maybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowPreferredDeals?: Maybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowTeaserRibbon?: Maybe<Scalars['Boolean']>;
  allowTeaserVideos?: Maybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: Maybe<Scalars['Boolean']>;
  allowVevIntegration?: Maybe<Scalars['Boolean']>;
  allowedCurrencies?: Maybe<Array<Currencies>>;
  allowedMarketplaces?: Maybe<Array<Marketplace>>;
  allowedTeaserFormatTypes: Array<TeaserFormatType>;
  allowedTeaserFormats: Array<TeaserFormat>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discounts?: Maybe<Array<CompanyDiscount>>;
  image?: Maybe<Scalars['String']>;
  /** JSON Schema defining valid label configurations for this company */
  labelSchema?: Maybe<Scalars['JSONObject']>;
  labels: Array<Label>;
  marketplace?: Maybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  targetingSections: Array<Scalars['String']>;
  type: CompanyType;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
  v2migration: V2Migration;
};

export type CompanyDiscount = {
  __typename?: 'CompanyDiscount';
  companyId: Scalars['ObjectId'];
  discount: Scalars['Decimal'];
  platformFee?: Maybe<Scalars['Decimal']>;
};

export type CompanyDiscountInput = {
  companyId: Scalars['ObjectId'];
  discount: Scalars['Decimal'];
  platformFee?: InputMaybe<Scalars['Decimal']>;
};

export type CompanyFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  search?: InputMaybe<Scalars['String']>;
  /** Filter by one or more types. Can be a string or an array of strings. */
  type?: InputMaybe<Array<CompanyType>>;
};

/** Assign a type to company */
export enum CompanyType {
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  None = 'NONE',
  Publisher = 'PUBLISHER'
}

/** Campaign targeting consent statuses */
export enum ConsentStatus {
  Consented = 'CONSENTED',
  UnConsented = 'UN_CONSENTED'
}

export type Content = {
  __typename?: 'Content';
  articleByline?: Maybe<Scalars['String']>;
  contentImages?: Maybe<Array<Scalars['String']>>;
  contentObject?: Maybe<Scalars['JSONObject']>;
  coverImage?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imageByline?: Maybe<Scalars['String']>;
  teaser?: Maybe<Scalars['String']>;
};

export type ContentInput = {
  articleByline?: InputMaybe<Scalars['String']>;
  contentImages?: InputMaybe<Array<Scalars['String']>>;
  contentObject?: InputMaybe<Scalars['JSONObject']>;
  coverImage?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  imageByline?: InputMaybe<Scalars['String']>;
  teaser?: InputMaybe<Scalars['String']>;
};

/** Source of the content */
export enum ContentProvider {
  Vev = 'VEV'
}

/** Publication conversion action types */
export enum ConversionAction {
  Click = 'CLICK',
  Lead = 'LEAD',
  Read = 'READ'
}

export type ConversionTag = {
  __typename?: 'ConversionTag';
  action: ConversionAction;
  tagType: ConversionTagType;
  tagURL: Scalars['String'];
};

/** Publication conversion tag types */
export enum ConversionTagType {
  Pixel = 'PIXEL',
  Script = 'SCRIPT'
}

export type CreateAdvertiserInput = {
  /** Fill in only if you want to create an account admin for this advertiser */
  adminEmail?: InputMaybe<Scalars['String']>;
  /** Fill in only if you want to create an account admin for this advertiser */
  adminFirstName?: InputMaybe<Scalars['String']>;
  adminLastName?: InputMaybe<Scalars['String']>;
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateCampaignInput = {
  advertiserId: Scalars['ObjectId'];
  billingId?: InputMaybe<Scalars['String']>;
  budgetDeduction?: InputMaybe<Scalars['Decimal']>;
  content?: InputMaybe<ContentInput>;
  contentSource?: InputMaybe<CampaignContentSource>;
  country?: InputMaybe<Scalars['String']>;
  dailyBudgetLimit?: InputMaybe<Scalars['Decimal']>;
  dealId?: InputMaybe<Scalars['ObjectId']>;
  disableSEO?: InputMaybe<Scalars['Boolean']>;
  ecpmOptimization?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  labels?: InputMaybe<Array<Scalars['ObjectId']>>;
  landingPage?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<Marketplace>;
  name: Scalars['String'];
  optimisation?: InputMaybe<CampaignOptimisationType>;
  pacing?: InputMaybe<CampaignPacing>;
  policyUrl?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<CampaignPriorityType>;
  publications?: InputMaybe<Array<PublicationInput>>;
  rateCard?: InputMaybe<CampaignRateCardInput>;
  sensitiveCategory?: InputMaybe<CampaignSensitiveCategory>;
  sponsor?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  targetType?: InputMaybe<CampaignTargetType>;
  targetValue?: InputMaybe<Scalars['Decimal']>;
  targeting?: InputMaybe<TargetingInput>;
  trackingTag?: InputMaybe<TrackingTagInput>;
  type?: InputMaybe<CampaignType>;
};

export type CreateCompanyInput = {
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};

export type CreateDealInput = {
  advertiserId: Scalars['ObjectId'];
  buyerId: Scalars['ObjectId'];
  campaignType: DealCampaignType;
  platformDiscount: Scalars['Decimal'];
  websiteIds: Array<Scalars['ObjectId']>;
};

export type CreateDriverTemplateInput = {
  maxTeasers?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  publisherId: Scalars['ObjectId'];
  renderMode: DriverTemplateRenderMode;
  templateCode?: InputMaybe<Scalars['String']>;
};

export type CreateIabContentCategory = {
  name: Scalars['String'];
  parentId: Scalars['String'];
  textPath?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateLabelInput = {
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  configuration?: InputMaybe<Scalars['JSONObject']>;
  name: Scalars['String'];
};

export type CreateLeadInput = {
  formData: Array<LeadFormDataInput>;
  publicationId: Scalars['ObjectId'];
};

export type CreatePlacementInput = {
  allowedCampaigns?: InputMaybe<AllowedCampaigns>;
  audienceExtensionWebsites?: InputMaybe<Array<Scalars['ObjectId']>>;
  driverTemplateId: Scalars['ObjectId'];
  format?: InputMaybe<TeaserFormatType>;
  key: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  publisherId: Scalars['ObjectId'];
  rules?: InputMaybe<Array<PlacementRuleInput>>;
  templateSwitchers?: InputMaybe<Array<TemplateSwitcherInput>>;
  websiteId: Scalars['ObjectId'];
};

export type CreatePublisherInput = {
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateTeaserInput = {
  campaignId: Scalars['ObjectId'];
  destinationUrl?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<TeaserFormatType>;
  headline: Scalars['String'];
  imageId?: InputMaybe<Scalars['String']>;
  ribbon?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TeaserStatus>;
  targeting?: InputMaybe<TeaserTargetingInput>;
  targetingEpomId?: InputMaybe<Scalars['Int']>;
  targetingEpomIds?: InputMaybe<Array<Scalars['Int']>>;
  teaser?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['ObjectId']>;
  websiteIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type CreateTrackonomicsIntegrationInput = {
  apiToken: Scalars['String'];
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  email: Scalars['String'];
  envCode: Scalars['String'];
  password: Scalars['String'];
};

export type CreateUserInput = {
  allowPasswordLogin?: InputMaybe<Scalars['Boolean']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ObjectId'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateVevIntegrationInput = {
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  vevSecret: Scalars['String'];
};

export type CreateVideoInput = {
  /** Associate video with an advertiser. */
  advertiserId?: InputMaybe<Scalars['ObjectId']>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  /** A publicly accessible URL for downloading the video. */
  videoDownloadUrl: Scalars['String'];
};

export type CreateWebsiteInput = {
  adsolutelyBoxId?: InputMaybe<Scalars['String']>;
  adsolutelyId?: InputMaybe<Scalars['String']>;
  advertorialSite?: InputMaybe<AdvertorialSiteInput>;
  allowContimoHostedAdvertorials?: InputMaybe<Scalars['Boolean']>;
  allowProviderContentAdvertorials?: InputMaybe<Scalars['Boolean']>;
  allowSelfHostedAdvertorials?: InputMaybe<Scalars['Boolean']>;
  cpcFloorPrice?: InputMaybe<Scalars['Decimal']>;
  cprFloorPrice?: InputMaybe<Scalars['Decimal']>;
  ctaButtonSelector?: InputMaybe<Scalars['String']>;
  enabledOnMarketplace?: InputMaybe<Scalars['Boolean']>;
  /** Company IDs exempt from floor price. Available only for SuperAdmins. */
  floorPriceExemptCompanyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  internalArticleId?: InputMaybe<Scalars['String']>;
  minimumSpend?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  prohibitMarketplaceDisplay?: InputMaybe<Scalars['Boolean']>;
  type: WebsiteType;
  url: Scalars['String'];
};

/** Allowed currencies */
export enum Currencies {
  Dkk = 'DKK',
  Eur = 'EUR',
  Nok = 'NOK',
  Sek = 'SEK',
  Usd = 'USD'
}

/** Campaign targeting day of week type */
export enum DayOfWeekType {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Deal = {
  __typename?: 'Deal';
  _id: Scalars['ObjectId'];
  advertiser?: Maybe<Advertiser>;
  advertiserId: Scalars['ObjectId'];
  buyer?: Maybe<Company>;
  buyerId: Scalars['ObjectId'];
  campaign?: Maybe<Campaign>;
  campaignCreationLink?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ObjectId']>;
  campaignType: DealCampaignType;
  createdAt: Scalars['DateTime'];
  creatorId?: Maybe<Scalars['ObjectId']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  platformDiscount: Scalars['Decimal'];
  publisher?: Maybe<Publisher>;
  publisherId: Scalars['ObjectId'];
  revenue?: Maybe<Scalars['Float']>;
  status: DealStatus;
  updatedAt: Scalars['DateTime'];
  websiteIds: Array<Scalars['ObjectId']>;
  websites: Array<Website>;
};

/** Deal campaign type options */
export enum DealCampaignType {
  Content = 'CONTENT',
  Display = 'DISPLAY'
}

export type DealFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Deal status options */
export enum DealStatus {
  Active = 'ACTIVE',
  Used = 'USED'
}

/** Device types */
export enum Device {
  All = 'ALL',
  DesktopLaptop = 'DESKTOP_LAPTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

/** Campaign targeting device type */
export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

/** Document operation types */
export enum DocOperationType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type DriverTemplate = {
  __typename?: 'DriverTemplate';
  _id: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  maxTeasers?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  publisherId: Scalars['ObjectId'];
  renderMode: DriverTemplateRenderMode;
  templateCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type DriverTemplateFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current publisher id. Available only for SuperAdmins. */
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

/** DriverTemplate render mode options */
export enum DriverTemplateRenderMode {
  ContimoWidget = 'CONTIMO_WIDGET',
  FriendlyIframe = 'FRIENDLY_IFRAME',
  Inline = 'INLINE'
}

/** Assign a hosting type to the AdvertorialSite */
export enum HostingType {
  ContimoDomain = 'CONTIMO_DOMAIN',
  Path = 'PATH',
  Subdomain = 'SUBDOMAIN'
}

export type IabContentCategory = {
  __typename?: 'IABContentCategory';
  _id: Scalars['String'];
  children: Array<IabContentCategory>;
  name: Scalars['String'];
  parentId: Scalars['String'];
  textPath?: Maybe<Array<Scalars['String']>>;
};

export type IntegrationFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Integration type */
export enum IntegrationType {
  Trackonomics = 'TRACKONOMICS',
  Vev = 'VEV'
}

export type Invitation = {
  __typename?: 'Invitation';
  allowPasswordLogin: Scalars['Boolean'];
  companyId: Scalars['ObjectId'];
  companyType: CompanyType;
  role: UserRole;
  userId: Scalars['ObjectId'];
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Label = {
  __typename?: 'Label';
  _id: Scalars['ObjectId'];
  companyId: Scalars['ObjectId'];
  /** JSON data complying with Company's labelSchema */
  configuration?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** @deprecated Use dynamic configuration JSON instead */
  teaserField?: Maybe<Scalars['String']>;
  /** @deprecated Use dynamic configuration JSON instead */
  teaserValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LabelFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

export type Lead = {
  __typename?: 'Lead';
  _id: Scalars['ObjectId'];
  campaign: Campaign;
  campaignId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  formData?: Maybe<Array<LeadFormData>>;
  publication: Publication;
  publicationId: Scalars['ObjectId'];
  status?: Maybe<LeadStatus>;
  updatedAt: Scalars['DateTime'];
  website: Website;
  websiteId: Scalars['ObjectId'];
};

export type LeadFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  campaignId?: InputMaybe<Scalars['ObjectId']>;
  publicationId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

export type LeadFormData = {
  __typename?: 'LeadFormData';
  label: Scalars['String'];
  type: LeadFormItemType;
  value: Scalars['String'];
};

export type LeadFormDataInput = {
  label: Scalars['String'];
  type: LeadFormItemType;
  value: Scalars['String'];
};

/** Lead form item types */
export enum LeadFormItemType {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  Text = 'TEXT'
}

/** Lead statuses */
export enum LeadStatus {
  Approved = 'APPROVED',
  Submitted = 'SUBMITTED'
}

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  rule?: Maybe<LocationRule>;
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  /** Default is INCLUDE */
  rule?: InputMaybe<LocationRule>;
};

/** Geo location targeting rules */
export enum LocationRule {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

/** Marketplaces available for the company. */
export enum Marketplace {
  Contimo = 'CONTIMO',
  Step = 'STEP'
}

export type MarketplaceWebsiteFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  campaignType: CampaignType;
  contentSource?: InputMaybe<Array<CampaignContentSource>>;
  marketplace: Marketplace;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<WebsiteType>>;
};

/** Mobile carrier for campaign targeting */
export enum MobileCarrier {
  Movistar = 'MOVISTAR',
  Tdc = 'TDC',
  Telenor = 'TELENOR',
  Telia = 'TELIA',
  Three = 'THREE'
}

export type Mutation = {
  __typename?: 'Mutation';
  AdvertiserCreateOne: Advertiser;
  AdvertiserUpdateById: Advertiser;
  AgencyCreateOne: Agency;
  CampaignClone?: Maybe<Campaign>;
  CampaignCreateOne: Campaign;
  CampaignDeleteById: Scalars['Boolean'];
  CampaignUpdateById: Campaign;
  CompanyCreateOne: Company;
  CompanyUpdateById: Company;
  DealCreateOne: Deal;
  DealDeleteById: Scalars['Boolean'];
  DealUpdateById: Deal;
  DriverTemplateCreateOne: DriverTemplate;
  DriverTemplateDeleteById: Scalars['Boolean'];
  DriverTemplateUpdateById: DriverTemplate;
  ForceSyncCampaignToEpom: Campaign;
  IABContentCategoryCreateOne: IabContentCategory;
  LabelCreateOne: Label;
  LabelUpdateById: Label;
  NotificationSettingsSaveMany: Scalars['Boolean'];
  PlacementCreateOne: Placement;
  PlacementUpdateById: Placement;
  PublicationUpdateById: Publication;
  PublisherCreateOne: Publisher;
  PublisherUpdateById?: Maybe<Publisher>;
  RunCampaignAction: Campaign;
  RunMarketplaceAction: Campaign;
  RunPublicationAction: Publication;
  RunTeaserAction: Teaser;
  TeaserCreateMany: Array<Teaser>;
  TeaserCreateOne: Teaser;
  TeaserDeleteByID: Scalars['Boolean'];
  TeaserUpdateByID: Teaser;
  TeaserUpdateByIds: Array<Teaser>;
  TrackonomicsIntegrationCreateOne: TrackonomicsIntegration;
  TrackonomicsIntegrationDeleteById: Scalars['Boolean'];
  TrackonomicsIntegrationUpdateById: TrackonomicsIntegration;
  UserCreateOne: User;
  UserDeleteById: Scalars['Boolean'];
  UserUpdateById?: Maybe<User>;
  VevIntegrationCreateOne: VevIntegration;
  VevIntegrationDeleteById: Scalars['Boolean'];
  VevIntegrationUpdateById: VevIntegration;
  VideoCreateOne: Video;
  WebsiteCreateOne: Website;
  WebsiteUpdateById: Website;
  leadCollect: Lead;
};


export type MutationAdvertiserCreateOneArgs = {
  record: CreateAdvertiserInput;
};


export type MutationAdvertiserUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateAdvertiserInput;
};


export type MutationAgencyCreateOneArgs = {
  record: CreateCompanyInput;
};


export type MutationCampaignCloneArgs = {
  campaignId: Scalars['ObjectId'];
};


export type MutationCampaignCreateOneArgs = {
  record: CreateCampaignInput;
};


export type MutationCampaignDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationCampaignUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateCampaignInput;
};


export type MutationCompanyCreateOneArgs = {
  record: CreateCompanyInput;
};


export type MutationCompanyUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateCompanyInput;
};


export type MutationDealCreateOneArgs = {
  record: CreateDealInput;
};


export type MutationDealDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDealUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateDealInput;
};


export type MutationDriverTemplateCreateOneArgs = {
  record: CreateDriverTemplateInput;
};


export type MutationDriverTemplateDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDriverTemplateUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateDriverTemplateInput;
};


export type MutationForceSyncCampaignToEpomArgs = {
  campaignId: Scalars['ObjectId'];
};


export type MutationIabContentCategoryCreateOneArgs = {
  record: CreateIabContentCategory;
};


export type MutationLabelCreateOneArgs = {
  record: CreateLabelInput;
};


export type MutationLabelUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateLabelInput;
};


export type MutationNotificationSettingsSaveManyArgs = {
  record: NotificationSettingsInput;
};


export type MutationPlacementCreateOneArgs = {
  record: CreatePlacementInput;
};


export type MutationPlacementUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdatePlacementInput;
};


export type MutationPublicationUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdatePublicationInput;
};


export type MutationPublisherCreateOneArgs = {
  record: CreatePublisherInput;
};


export type MutationPublisherUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdatePublisherInput;
};


export type MutationRunCampaignActionArgs = {
  action: Scalars['String'];
  campaignId: Scalars['ObjectId'];
};


export type MutationRunMarketplaceActionArgs = {
  campaignId: Scalars['ObjectId'];
  input: RunMarketplaceActionInput;
};


export type MutationRunPublicationActionArgs = {
  action: Scalars['String'];
  publicationId: Scalars['ObjectId'];
};


export type MutationRunTeaserActionArgs = {
  publisherApprovalStatus: PublisherApprovalStatus;
  teaserId: Scalars['ObjectId'];
  websiteIds: Array<Scalars['ObjectId']>;
};


export type MutationTeaserCreateManyArgs = {
  records: Array<CreateTeaserInput>;
};


export type MutationTeaserCreateOneArgs = {
  record: CreateTeaserInput;
};


export type MutationTeaserDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationTeaserUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateTeaserInput;
};


export type MutationTeaserUpdateByIdsArgs = {
  records: Array<BulkUpdateTeaserInput>;
};


export type MutationTrackonomicsIntegrationCreateOneArgs = {
  record: CreateTrackonomicsIntegrationInput;
};


export type MutationTrackonomicsIntegrationDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationTrackonomicsIntegrationUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateTrackonomicsIntegrationInput;
};


export type MutationUserCreateOneArgs = {
  record: CreateUserInput;
};


export type MutationUserDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationUserUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateUserInput;
};


export type MutationVevIntegrationCreateOneArgs = {
  record: CreateVevIntegrationInput;
};


export type MutationVevIntegrationDeleteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationVevIntegrationUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateVevIntegrationInput;
};


export type MutationVideoCreateOneArgs = {
  record: CreateVideoInput;
};


export type MutationWebsiteCreateOneArgs = {
  input: CreateWebsiteInput;
};


export type MutationWebsiteUpdateByIdArgs = {
  _id: Scalars['ObjectId'];
  record: UpdateWebsiteInput;
};


export type MutationLeadCollectArgs = {
  input: CreateLeadInput;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  _id: Scalars['ObjectId'];
  companyId: Scalars['ObjectId'];
  notification: NotificationType;
  user: User;
  userId: Scalars['ObjectId'];
};

export type NotificationSettingsInput = {
  settings: Array<UserNotificationSettingsInput>;
};

/** Type of notification */
export enum NotificationType {
  CampaignAwaitingContimoApproval = 'CAMPAIGN_AWAITING_CONTIMO_APPROVAL',
  NewCampaignApproval = 'NEW_CAMPAIGN_APPROVAL'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  perPage: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedAdvertiserResponse = {
  __typename?: 'PaginatedAdvertiserResponse';
  items: Array<Advertiser>;
  meta: PageInfo;
};

export type PaginatedCampaignResponse = {
  __typename?: 'PaginatedCampaignResponse';
  items: Array<Campaign>;
  meta: PageInfo;
};

export type PaginatedChangeLogResponse = {
  __typename?: 'PaginatedChangeLogResponse';
  items: Array<ChangeLog>;
  meta: PageInfo;
};

export type PaginatedCompanyResponse = {
  __typename?: 'PaginatedCompanyResponse';
  items: Array<Company>;
  meta: PageInfo;
};

export type PaginatedDealResponse = {
  __typename?: 'PaginatedDealResponse';
  items: Array<Deal>;
  meta: PageInfo;
};

export type PaginatedDriverTemplateResponse = {
  __typename?: 'PaginatedDriverTemplateResponse';
  items: Array<DriverTemplate>;
  meta: PageInfo;
};

export type PaginatedLabelResponse = {
  __typename?: 'PaginatedLabelResponse';
  items: Array<Label>;
  meta: PageInfo;
};

export type PaginatedLeadResponse = {
  __typename?: 'PaginatedLeadResponse';
  items: Array<Lead>;
  meta: PageInfo;
};

export type PaginatedPlacementResponse = {
  __typename?: 'PaginatedPlacementResponse';
  items: Array<Placement>;
  meta: PageInfo;
};

export type PaginatedProviderContentResponse = {
  __typename?: 'PaginatedProviderContentResponse';
  items: Array<ProviderContent>;
  meta: PageInfo;
};

export type PaginatedPublicationResponse = {
  __typename?: 'PaginatedPublicationResponse';
  items: Array<Publication>;
  meta: PageInfo;
};

export type PaginatedPublisherResponse = {
  __typename?: 'PaginatedPublisherResponse';
  items: Array<Publisher>;
  meta: PageInfo;
};

export type PaginatedTeaserResponse = {
  __typename?: 'PaginatedTeaserResponse';
  items: Array<Teaser>;
  meta: PageInfo;
};

export type PaginatedTrackonomicsIntegrationResponse = {
  __typename?: 'PaginatedTrackonomicsIntegrationResponse';
  items: Array<TrackonomicsIntegration>;
  meta: PageInfo;
};

export type PaginatedUserResponse = {
  __typename?: 'PaginatedUserResponse';
  items: Array<User>;
  meta: PageInfo;
};

export type PaginatedVevIntegrationResponse = {
  __typename?: 'PaginatedVevIntegrationResponse';
  items: Array<VevIntegration>;
  meta: PageInfo;
};

export type PaginatedVideoResponse = {
  __typename?: 'PaginatedVideoResponse';
  items: Array<Video>;
  meta: PageInfo;
};

export type PaginatedWebsiteResponse = {
  __typename?: 'PaginatedWebsiteResponse';
  items: Array<Website>;
  meta: PageInfo;
};

export type Placement = {
  __typename?: 'Placement';
  _id: Scalars['ObjectId'];
  allowedCampaigns?: Maybe<AllowedCampaigns>;
  audienceExtensionWebsites?: Maybe<Array<Scalars['ObjectId']>>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  driverTemplateId: Scalars['ObjectId'];
  epomId?: Maybe<Scalars['Int']>;
  epomKey?: Maybe<Scalars['String']>;
  format?: Maybe<TeaserFormatType>;
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  publisherId: Scalars['ObjectId'];
  rules?: Maybe<Array<PlacementRule>>;
  templateSwitchers?: Maybe<Array<TemplateSwitcher>>;
  updatedAt: Scalars['DateTime'];
  website?: Maybe<Website>;
  websiteId: Scalars['ObjectId'];
};

export type PlacementFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current publisher id. Available only for SuperAdmins. */
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
};

export type PlacementRule = {
  __typename?: 'PlacementRule';
  campaignTypes?: Maybe<Array<CampaignType>>;
  labels?: Maybe<Array<Label>>;
  sensitiveCategories?: Maybe<Array<CampaignSensitiveCategory>>;
  type: PlacementRuleType;
};

export type PlacementRuleInput = {
  campaignTypes?: InputMaybe<Array<CampaignType>>;
  labels?: InputMaybe<Array<Scalars['ObjectId']>>;
  sensitiveCategories?: InputMaybe<Array<CampaignSensitiveCategory>>;
  type: PlacementRuleType;
};

/** Placement rule type */
export enum PlacementRuleType {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type ProviderContent = {
  __typename?: 'ProviderContent';
  _id: Scalars['ObjectId'];
  companyId: Scalars['ObjectId'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  payload: Scalars['JSON'];
  previewUrl: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  projectTitle?: Maybe<Scalars['String']>;
  provider: ContentProvider;
  sourceId: Scalars['String'];
  status: ProviderContentStatus;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type ProviderContentFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  provider?: InputMaybe<ContentProvider>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProviderContentStatus>;
};

/** Status of the article */
export enum ProviderContentStatus {
  Archived = 'ARCHIVED',
  Current = 'CURRENT',
  Unpublished = 'UNPUBLISHED'
}

export type Publication = {
  __typename?: 'Publication';
  _id: Scalars['ObjectId'];
  actions?: Maybe<Array<PublicationAction>>;
  advertiser?: Maybe<Advertiser>;
  advertiserId: Scalars['ObjectId'];
  bidPriceForCampaign?: Maybe<Scalars['Float']>;
  budget?: Maybe<Scalars['Decimal']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ObjectId'];
  comment?: Maybe<Scalars['String']>;
  content?: Maybe<Content>;
  contentOverwritten?: Maybe<Scalars['Boolean']>;
  conversionTags?: Maybe<Array<ConversionTag>>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['ObjectId']>;
  /** @deprecated Use `deletedAt` date type property instead. */
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  device?: Maybe<Device>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDateOverwritten?: Maybe<Scalars['Boolean']>;
  everActivated?: Maybe<Scalars['Boolean']>;
  finalUrl?: Maybe<Scalars['String']>;
  isSelfHosted?: Maybe<Scalars['Boolean']>;
  kpi?: Maybe<Scalars['String']>;
  landingPage?: Maybe<Scalars['String']>;
  landingPageOverwritten?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  ownerCompanyId?: Maybe<Scalars['ObjectId']>;
  placementIds?: Maybe<Array<Scalars['ObjectId']>>;
  placements?: Maybe<Array<Placement>>;
  previewUrl?: Maybe<Scalars['String']>;
  providerContent?: Maybe<PublicationProviderContent>;
  providerContentObject?: Maybe<ProviderContent>;
  publicationDate?: Maybe<Scalars['DateTime']>;
  publicationType?: Maybe<PublicationType>;
  publisher?: Maybe<Publisher>;
  publisherId: Scalars['ObjectId'];
  rateCard?: Maybe<RateCard>;
  selfHostedContent?: Maybe<SelfHostedContent>;
  shortId: Scalars['String'];
  slug: Scalars['String'];
  stage?: Maybe<PublicationStage>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDateOverwritten?: Maybe<Scalars['Boolean']>;
  status?: Maybe<PublicationStatus>;
  teasers: Array<Teaser>;
  trackingTag?: Maybe<TrackingTag>;
  updatedAt: Scalars['DateTime'];
  website?: Maybe<Website>;
  websiteId: Scalars['ObjectId'];
};


export type PublicationBidPriceForCampaignArgs = {
  campaignId: Scalars['ObjectId'];
};

export type PublicationAction = {
  __typename?: 'PublicationAction';
  action: PublicationActionType;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledReason?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
};

export type PublicationActionInput = {
  action: PublicationActionType;
  publicationId: Scalars['ObjectId'];
};

/** Publication action types */
export enum PublicationActionType {
  Accept = 'ACCEPT',
  Finish = 'FINISH',
  Pause = 'PAUSE',
  Reject = 'REJECT',
  Resume = 'RESUME',
  SubmitToWebsite = 'SUBMIT_TO_WEBSITE',
  ToDraft = 'TO_DRAFT'
}

export type PublicationFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  campaignId?: InputMaybe<Array<Scalars['ObjectId']>>;
  search?: InputMaybe<Scalars['String']>;
  /** The status can be a `string` or an `array` (ex: status: ["DRAFT", "PENDING"] or status: "DRAFT") */
  status?: InputMaybe<Array<PublicationStatus>>;
};

export type PublicationInput = {
  budget?: InputMaybe<Scalars['Decimal']>;
  isSelfHosted?: InputMaybe<Scalars['Boolean']>;
  providerContent?: InputMaybe<PublicationProviderContentInput>;
  selfHostedContent?: InputMaybe<SelfHostedContentInput>;
  websiteId?: InputMaybe<Scalars['ObjectId']>;
};

export type PublicationProviderContent = {
  __typename?: 'PublicationProviderContent';
  providerContentId: Scalars['ObjectId'];
};

export type PublicationProviderContentInput = {
  providerContentId: Scalars['ObjectId'];
};

/** Publication stages */
export enum PublicationStage {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  PreDraft = 'PRE_DRAFT',
  Published = 'PUBLISHED',
  WaitingForAdvertiser = 'WAITING_FOR_ADVERTISER',
  WaitingForPublisher = 'WAITING_FOR_PUBLISHER'
}

/** Publication statuses */
export enum PublicationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Paused = 'PAUSED',
  Ready = 'READY',
  ReviewingByPublisher = 'REVIEWING_BY_PUBLISHER'
}

/** Publication types */
export enum PublicationType {
  ContimoHosted = 'CONTIMO_HOSTED',
  Manual = 'MANUAL'
}

export type Publisher = {
  __typename?: 'Publisher';
  _id: Scalars['ObjectId'];
  allowContentRecirculationCampaigns?: Maybe<Scalars['Boolean']>;
  allowCpcCpa?: Maybe<Scalars['Boolean']>;
  allowFillerCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: Maybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: Maybe<Scalars['Boolean']>;
  allowPreferredDeals?: Maybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: Maybe<Scalars['Boolean']>;
  allowTeaserRibbon?: Maybe<Scalars['Boolean']>;
  allowTeaserVideos?: Maybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: Maybe<Scalars['Boolean']>;
  allowVevIntegration?: Maybe<Scalars['Boolean']>;
  allowedCurrencies?: Maybe<Array<Currencies>>;
  allowedMarketplaces?: Maybe<Array<Marketplace>>;
  allowedTeaserFormatTypes: Array<TeaserFormatType>;
  allowedTeaserFormats: Array<TeaserFormat>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discounts?: Maybe<Array<CompanyDiscount>>;
  image?: Maybe<Scalars['String']>;
  /** JSON Schema defining valid label configurations for this company */
  labelSchema?: Maybe<Scalars['JSONObject']>;
  labels: Array<Label>;
  marketplace?: Maybe<Array<Marketplace>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['Decimal']>;
  slug: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  targetingSections: Array<Scalars['String']>;
  type: CompanyType;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
};

/** Teaser Assignment Publisher approval statuses */
export enum PublisherApprovalStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type Query = {
  __typename?: 'Query';
  AdvertiserById?: Maybe<Advertiser>;
  AdvertiserMany: PaginatedAdvertiserResponse;
  AgencyById?: Maybe<Agency>;
  AgencyMany: PaginatedCompanyResponse;
  AllowedCampaignTypes: Array<CampaignType>;
  CampaignById?: Maybe<Campaign>;
  /** @deprecated Use CampaignById endpoint instead */
  CampaignByIdForPreview?: Maybe<Campaign>;
  CampaignDeliveryOptions: CampaignDeliveryOptions;
  CampaignMany: PaginatedCampaignResponse;
  CampaignReport: Array<Report>;
  CampaignReportLegacy: Array<Report>;
  CampaignsWaiting: Array<Campaign>;
  CompanyById?: Maybe<Company>;
  CompanyMany: PaginatedCompanyResponse;
  CurrentCompany?: Maybe<Company>;
  CurrentUser?: Maybe<User>;
  DealById?: Maybe<Deal>;
  DealMany: PaginatedDealResponse;
  DriverTemplateById?: Maybe<DriverTemplate>;
  DriverTemplateMany: PaginatedDriverTemplateResponse;
  DriverTemplateOne?: Maybe<DriverTemplate>;
  GetInvitation?: Maybe<Invitation>;
  IABContentCategoryById?: Maybe<IabContentCategory>;
  IABContentCategoryRoot: Array<IabContentCategory>;
  LabelMany: PaginatedLabelResponse;
  LeadMany: PaginatedLeadResponse;
  MarketplaceWebsiteMany: PaginatedWebsiteResponse;
  /** Get all notification types */
  NotificationMany: Array<Scalars['String']>;
  /** Get all company notification settings */
  NotificationSettingsMany: Array<NotificationSettings>;
  PlacementById?: Maybe<Placement>;
  PlacementMany: PaginatedPlacementResponse;
  ProviderContentById?: Maybe<ProviderContent>;
  ProviderContentMany: PaginatedProviderContentResponse;
  PublicationById?: Maybe<Publication>;
  /** @deprecated Use PublicationById instead */
  PublicationByIdForPreview?: Maybe<Publication>;
  PublicationMany: PaginatedPublicationResponse;
  PublicationOne?: Maybe<Publication>;
  PublishedPublicationByShortId?: Maybe<Publication>;
  PublishedPublications: Array<Publication>;
  PublisherById?: Maybe<Publisher>;
  PublisherBySlug?: Maybe<Publisher>;
  PublisherMany: PaginatedPublisherResponse;
  Publishers: Array<Publisher>;
  RecommendedBidMultipliers?: Maybe<Array<RecommendedBidMultiplier>>;
  TargetingCities?: Maybe<Array<KeyValuePair>>;
  TargetingCountries?: Maybe<Array<KeyValuePair>>;
  TargetingRegions?: Maybe<Array<KeyValuePair>>;
  TeaserFormats: Array<TeaserFormat>;
  TeaserMany: PaginatedTeaserResponse;
  Teasers: Array<Teaser>;
  Timeline: Array<Timeline>;
  TrackonomicsIntegrationMany: PaginatedTrackonomicsIntegrationResponse;
  UserMany: PaginatedUserResponse;
  VevIntegrationMany: PaginatedVevIntegrationResponse;
  VideoById?: Maybe<VideoPlayDataResponse>;
  VideoMany: PaginatedVideoResponse;
  WebsiteById?: Maybe<Website>;
  WebsiteMany: PaginatedWebsiteResponse;
  changeLogMany: PaginatedChangeLogResponse;
};


export type QueryAdvertiserByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAdvertiserManyArgs = {
  filters?: InputMaybe<CompanyFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryAgencyByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAgencyManyArgs = {
  filters?: InputMaybe<CompanyFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryCampaignByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCampaignByIdForPreviewArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCampaignDeliveryOptionsArgs = {
  campaignType: CampaignType;
};


export type QueryCampaignManyArgs = {
  filters?: InputMaybe<CampaignFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryCampaignReportArgs = {
  endDate: Scalars['DateTime'];
  filters?: InputMaybe<ReportFilterArgs>;
  startDate: Scalars['DateTime'];
};


export type QueryCampaignReportLegacyArgs = {
  endDate: Scalars['DateTime'];
  filters?: InputMaybe<ReportFilterArgs>;
  startDate: Scalars['DateTime'];
};


export type QueryCompanyByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCompanyManyArgs = {
  filters?: InputMaybe<CompanyFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryDealByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryDealManyArgs = {
  filters?: InputMaybe<DealFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryDriverTemplateByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryDriverTemplateManyArgs = {
  filters?: InputMaybe<DriverTemplateFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryGetInvitationArgs = {
  email: Scalars['String'];
};


export type QueryIabContentCategoryByIdArgs = {
  _id: Scalars['String'];
};


export type QueryLabelManyArgs = {
  filters?: InputMaybe<LabelFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryLeadManyArgs = {
  filters?: InputMaybe<LeadFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryMarketplaceWebsiteManyArgs = {
  filters: MarketplaceWebsiteFilterArgs;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryPlacementByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPlacementManyArgs = {
  filters?: InputMaybe<PlacementFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryProviderContentByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryProviderContentManyArgs = {
  filters?: InputMaybe<ProviderContentFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryPublicationByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPublicationByIdForPreviewArgs = {
  publicationId: Scalars['ObjectId'];
};


export type QueryPublicationManyArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  filters?: InputMaybe<PublicationFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryPublishedPublicationByShortIdArgs = {
  shortId: Scalars['String'];
  websiteId: Scalars['ObjectId'];
};


export type QueryPublishedPublicationsArgs = {
  websiteId: Scalars['ObjectId'];
};


export type QueryPublisherByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPublisherBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPublisherManyArgs = {
  filters?: InputMaybe<CompanyFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryRecommendedBidMultipliersArgs = {
  filters?: InputMaybe<BidMultipliersFilterArgs>;
};


export type QueryTargetingCitiesArgs = {
  countryCode: Scalars['String'];
  region: Scalars['String'];
};


export type QueryTargetingRegionsArgs = {
  countryCode: Scalars['String'];
};


export type QueryTeaserManyArgs = {
  filters?: InputMaybe<TeaserFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryTrackonomicsIntegrationManyArgs = {
  filters?: InputMaybe<IntegrationFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryUserManyArgs = {
  filters?: InputMaybe<UserFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryVevIntegrationManyArgs = {
  filters?: InputMaybe<IntegrationFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryVideoByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryVideoManyArgs = {
  filters?: InputMaybe<VideoFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryWebsiteByIdArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryWebsiteManyArgs = {
  filters?: InputMaybe<WebsiteFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryChangeLogManyArgs = {
  filters?: InputMaybe<ChangeLogFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};

export type RateCard = {
  __typename?: 'RateCard';
  bidMultiplier?: Maybe<Scalars['Decimal']>;
  bidMultiplierChangedAt?: Maybe<Scalars['DateTime']>;
  click: Scalars['Decimal'];
  clickout: Scalars['Decimal'];
  cpm: Scalars['Decimal'];
  discount?: Maybe<Scalars['Decimal']>;
  lead: Scalars['Decimal'];
  platformFee?: Maybe<Scalars['Decimal']>;
  read: Scalars['Decimal'];
};

export type RateCardInput = {
  bidMultiplier?: InputMaybe<Scalars['Float']>;
  click?: InputMaybe<Scalars['Decimal']>;
  currency?: InputMaybe<Currencies>;
  discount?: InputMaybe<Scalars['Decimal']>;
  lead?: InputMaybe<Scalars['Decimal']>;
  read?: InputMaybe<Scalars['Decimal']>;
};

export type RecommendedBidMultiplier = {
  __typename?: 'RecommendedBidMultiplier';
  campaign?: Maybe<Campaign>;
  campaignDeliveryStatus?: Maybe<Scalars['String']>;
  campaignId: Scalars['ObjectId'];
  campaignWebsiteImpressions?: Maybe<Scalars['Float']>;
  currentBid?: Maybe<Scalars['Float']>;
  currentBidMultiplier?: Maybe<Scalars['Float']>;
  ownerCompany?: Maybe<Company>;
  ownerCompanyId: Scalars['ObjectId'];
  recommendedBid?: Maybe<Scalars['Float']>;
  recommendedBidMultiplier: Scalars['Float'];
  totalWebsiteImpressions?: Maybe<Scalars['Float']>;
  website?: Maybe<Website>;
  websiteAverageEcpm?: Maybe<Scalars['Float']>;
  websiteId: Scalars['ObjectId'];
};

export type Report = {
  __typename?: 'Report';
  advertiserId?: Maybe<Scalars['String']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']>;
  clicks?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  date?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Decimal']>;
  impressions?: Maybe<Scalars['Int']>;
  leads?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['DateTime']>;
  pageviews?: Maybe<Scalars['Int']>;
  payout?: Maybe<Scalars['Decimal']>;
  platformFee?: Maybe<Scalars['Decimal']>;
  publication?: Maybe<Publication>;
  publicationId?: Maybe<Scalars['String']>;
  publisherId?: Maybe<Scalars['String']>;
  reads?: Maybe<Scalars['Int']>;
  readtime?: Maybe<Scalars['Int']>;
  website?: Maybe<Website>;
  websiteId?: Maybe<Scalars['String']>;
  week?: Maybe<Scalars['DateTime']>;
};

export type ReportFilterArgs = {
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  publicationId?: InputMaybe<Scalars['String']>;
  publisherId?: InputMaybe<Scalars['String']>;
  websiteId?: InputMaybe<Scalars['String']>;
};

export type RunMarketplaceActionInput = {
  publicationActions?: InputMaybe<Array<PublicationActionInput>>;
  teaserActions?: InputMaybe<Array<TeaserActionInput>>;
};

export type SelfHostedContent = {
  __typename?: 'SelfHostedContent';
  cmsArticleId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type SelfHostedContentInput = {
  cmsArticleId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

/** SortInput direction: asc/desc */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  column: Scalars['String'];
  direction: SortDirection;
};

export type SyncStatus = {
  __typename?: 'SyncStatus';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<SyncStatusType>;
  updatedAt: Scalars['DateTime'];
};

/** Campaign sync statuses */
export enum SyncStatusType {
  NotSynced = 'NOT_SYNCED',
  Synced = 'SYNCED',
  SyncFailed = 'SYNC_FAILED',
  SyncRequested = 'SYNC_REQUESTED',
  SyncStarted = 'SYNC_STARTED'
}

export type Targeting = {
  __typename?: 'Targeting';
  consentStatus?: Maybe<Array<ConsentStatus>>;
  dayOfWeek?: Maybe<Array<DayOfWeekType>>;
  deviceType?: Maybe<Array<DeviceType>>;
  location?: Maybe<Array<Location>>;
  mobileCarrier?: Maybe<Array<MobileCarrier>>;
  sections?: Maybe<Array<Scalars['String']>>;
  timeRange?: Maybe<Array<TimeRange>>;
};

export type TargetingInput = {
  consentStatus?: InputMaybe<Array<ConsentStatus>>;
  dayOfWeek?: InputMaybe<Array<DayOfWeekType>>;
  deviceType?: InputMaybe<Array<DeviceType>>;
  location?: InputMaybe<Array<LocationInput>>;
  mobileCarrier?: InputMaybe<Array<MobileCarrier>>;
  sections?: InputMaybe<Array<Scalars['String']>>;
  timeRange?: InputMaybe<Array<TimeRangeInput>>;
};

export type Teaser = {
  __typename?: 'Teaser';
  _id: Scalars['ObjectId'];
  advertiserLogoUrl?: Maybe<Scalars['String']>;
  assignmentPlacements: Array<AssignmentPlacements>;
  assignments?: Maybe<Array<TeaserAssignment>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  destinationUrl?: Maybe<Scalars['String']>;
  format?: Maybe<TeaserFormatType>;
  headline: Scalars['String'];
  imageId?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  previewLinks: Array<TeaserPreviewLink>;
  publicationIds: Array<Scalars['ObjectId']>;
  publications: Array<Publication>;
  ribbon?: Maybe<Scalars['String']>;
  status?: Maybe<TeaserStatus>;
  targeting?: Maybe<TeaserTargeting>;
  targetingEpomId?: Maybe<Scalars['Int']>;
  targetingEpomIds?: Maybe<Array<Scalars['Int']>>;
  teaser?: Maybe<Scalars['String']>;
  type?: Maybe<TeaserType>;
  updatedAt: Scalars['DateTime'];
  version?: Maybe<Scalars['Int']>;
  video?: Maybe<Video>;
  videoId?: Maybe<Scalars['ObjectId']>;
  websiteIds: Array<Scalars['ObjectId']>;
  websites?: Maybe<Array<Website>>;
  weight?: Maybe<Scalars['Int']>;
};

export type TeaserActionInput = {
  publisherApprovalStatus: PublisherApprovalStatus;
  teaserId: Scalars['ObjectId'];
  websiteIds: Array<Scalars['ObjectId']>;
};

export type TeaserAssignment = {
  __typename?: 'TeaserAssignment';
  epomId?: Maybe<Scalars['Int']>;
  publicationId: Scalars['ObjectId'];
  publisherApprovalStatus?: Maybe<PublisherApprovalStatus>;
  publisherId: Scalars['ObjectId'];
  status?: Maybe<AssignmentStatus>;
  websiteId: Scalars['ObjectId'];
};

export type TeaserFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  campaignId?: InputMaybe<Scalars['ObjectId']>;
  publicationId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  /** The `status` can be a `string` or an `array` */
  status?: InputMaybe<Array<TeaserStatus>>;
  type?: InputMaybe<Array<TeaserType>>;
  websiteId?: InputMaybe<Scalars['ObjectId']>;
};

export type TeaserFormat = {
  __typename?: 'TeaserFormat';
  cloudinaryTransform: Scalars['String'];
  displayName: Scalars['String'];
  minImageSize: TeaserFormatImageSize;
  recommendedAspectRatio: Scalars['String'];
  type: TeaserFormatType;
};

export type TeaserFormatImageSize = {
  __typename?: 'TeaserFormatImageSize';
  height: Scalars['Float'];
  width: Scalars['Float'];
};

/** Supported teaser format identifiers */
export enum TeaserFormatType {
  Display_320x120 = 'DISPLAY_320x120',
  Display_320x320 = 'DISPLAY_320x320',
  Display_930x180 = 'DISPLAY_930x180',
  Native = 'NATIVE'
}

export type TeaserPreviewLink = {
  __typename?: 'TeaserPreviewLink';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
  websiteId: Scalars['ObjectId'];
  websiteName: Scalars['String'];
};

/** Teaser statuses */
export enum TeaserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type TeaserTargeting = {
  __typename?: 'TeaserTargeting';
  categoriesId: Array<Scalars['String']>;
  mode?: Maybe<TeaserTargetingMode>;
};

export type TeaserTargetingInput = {
  categoriesId: Array<Scalars['String']>;
  mode?: InputMaybe<TeaserTargetingMode>;
};

/** Teaser targeting mode options */
export enum TeaserTargetingMode {
  AnyContentCategory = 'ANY_CONTENT_CATEGORY',
  ExactContentCategories = 'EXACT_CONTENT_CATEGORIES',
  ExcludeExactContentCategories = 'EXCLUDE_EXACT_CONTENT_CATEGORIES'
}

/** Assign a type to the teaser */
export enum TeaserType {
  Referral = 'REFERRAL',
  Standard = 'STANDARD'
}

export type TemplateSwitcher = {
  __typename?: 'TemplateSwitcher';
  teasers: Scalars['Int'];
  templateId: Scalars['ObjectId'];
};

export type TemplateSwitcherInput = {
  teasers: Scalars['Int'];
  templateId: Scalars['ObjectId'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  timeFrom: Scalars['Time24'];
  timeTo: Scalars['Time24'];
};

export type TimeRangeInput = {
  timeFrom: Scalars['Time24'];
  timeTo: Scalars['Time24'];
};

export type Timeline = {
  __typename?: 'Timeline';
  _id: Scalars['ObjectId'];
  action?: Maybe<TimelineAction>;
  campaignId: Campaign;
  companyIds: Array<Company>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONObject']>;
  publication?: Maybe<Publication>;
  publicationId: Publication;
  user?: Maybe<User>;
  userId: User;
};

/** Timeline actions */
export enum TimelineAction {
  CampaignCreated = 'CAMPAIGN_CREATED',
  PublicationApproved = 'PUBLICATION_APPROVED',
  PublicationCreated = 'PUBLICATION_CREATED',
  PublicationPublished = 'PUBLICATION_PUBLISHED',
  PublicationSentToApproval = 'PUBLICATION_SENT_TO_APPROVAL'
}

export type TrackingTag = {
  __typename?: 'TrackingTag';
  tagType?: Maybe<CampaignTagType>;
  tagUrl?: Maybe<Scalars['String']>;
};

export type TrackingTagInput = {
  tagType?: InputMaybe<CampaignTagType>;
  tagUrl?: InputMaybe<Scalars['String']>;
};

export type TrackonomicsIntegration = {
  __typename?: 'TrackonomicsIntegration';
  _id: Scalars['ObjectId'];
  apiToken: Scalars['String'];
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  envCode: Scalars['String'];
  password: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['DateTime'];
};

export type UpdateAdvertiserInput = {
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateCampaignInput = {
  advertiserId?: InputMaybe<Scalars['ObjectId']>;
  billingId?: InputMaybe<Scalars['String']>;
  budgetDeduction?: InputMaybe<Scalars['Decimal']>;
  content?: InputMaybe<ContentInput>;
  contentSource?: InputMaybe<CampaignContentSource>;
  country?: InputMaybe<Scalars['String']>;
  dailyBudgetLimit?: InputMaybe<Scalars['Decimal']>;
  dealId?: InputMaybe<Scalars['ObjectId']>;
  disableSEO?: InputMaybe<Scalars['Boolean']>;
  ecpmOptimization?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  labels?: InputMaybe<Array<Scalars['ObjectId']>>;
  landingPage?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<Marketplace>;
  name?: InputMaybe<Scalars['String']>;
  optimisation?: InputMaybe<CampaignOptimisationType>;
  pacing?: InputMaybe<CampaignPacing>;
  policyUrl?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<CampaignPriorityType>;
  publications?: InputMaybe<Array<PublicationInput>>;
  rateCard?: InputMaybe<CampaignRateCardInput>;
  sensitiveCategory?: InputMaybe<CampaignSensitiveCategory>;
  sponsor?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  targetType?: InputMaybe<CampaignTargetType>;
  targetValue?: InputMaybe<Scalars['Decimal']>;
  targeting?: InputMaybe<TargetingInput>;
  trackingTag?: InputMaybe<TrackingTagInput>;
  type?: InputMaybe<CampaignType>;
};

export type UpdateCompanyInput = {
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDealInput = {
  websiteIds: Array<Scalars['ObjectId']>;
};

export type UpdateDriverTemplateInput = {
  maxTeasers?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  renderMode?: InputMaybe<DriverTemplateRenderMode>;
  templateCode?: InputMaybe<Scalars['String']>;
};

export type UpdateLabelInput = {
  configuration?: InputMaybe<Scalars['JSONObject']>;
  name: Scalars['String'];
};

export type UpdatePlacementInput = {
  allowedCampaigns?: InputMaybe<AllowedCampaigns>;
  audienceExtensionWebsites?: InputMaybe<Array<Scalars['ObjectId']>>;
  driverTemplateId?: InputMaybe<Scalars['ObjectId']>;
  format?: InputMaybe<TeaserFormatType>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  rules?: InputMaybe<Array<PlacementRuleInput>>;
  templateSwitchers?: InputMaybe<Array<TemplateSwitcherInput>>;
  websiteId?: InputMaybe<Scalars['ObjectId']>;
};

export type UpdatePublicationInput = {
  advertiserId?: InputMaybe<Scalars['ObjectId']>;
  budget?: InputMaybe<Scalars['Decimal']>;
  campaignId?: InputMaybe<Scalars['ObjectId']>;
  comment?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<ContentInput>;
  device?: InputMaybe<Device>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isSelfHosted?: InputMaybe<Scalars['Boolean']>;
  landingPage?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placementIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  providerContent?: InputMaybe<PublicationProviderContentInput>;
  publicationDate?: InputMaybe<Scalars['DateTime']>;
  publicationType?: InputMaybe<PublicationType>;
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  rateCard?: InputMaybe<RateCardInput>;
  selfHostedContent?: InputMaybe<SelfHostedContentInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  trackingTag?: InputMaybe<TrackingTagInput>;
  websiteId?: InputMaybe<Scalars['ObjectId']>;
};

export type UpdatePublisherInput = {
  allowContentRecirculationCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowCpcCpa?: InputMaybe<Scalars['Boolean']>;
  allowFillerCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowInHouseNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceCpa?: InputMaybe<Scalars['Boolean']>;
  allowMarketplaceNativeCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowPrioritiseInHouseCampaigns?: InputMaybe<Scalars['Boolean']>;
  allowTeaserRibbon?: InputMaybe<Scalars['Boolean']>;
  allowTeaserVideos?: InputMaybe<Scalars['Boolean']>;
  allowTrackonomicsIntegration?: InputMaybe<Scalars['Boolean']>;
  allowVevIntegration?: InputMaybe<Scalars['Boolean']>;
  /** The currencies that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedCurrencies?: InputMaybe<Array<Currencies>>;
  /** The marketplaces that the company is allowed to operate in. Only SuperAdmins can update this field. */
  allowedMarketplaces?: InputMaybe<Array<Marketplace>>;
  /** Teaser formats enabled for the company. Only SuperAdmins can update this field. */
  allowedTeaserFormatTypes?: InputMaybe<Array<TeaserFormatType>>;
  country?: InputMaybe<Scalars['String']>;
  /** The discounts that the company offers. Only SuperAdmins can update this field. */
  discounts?: InputMaybe<Array<CompanyDiscountInput>>;
  image?: InputMaybe<Scalars['String']>;
  /** JSON validation schema for company's labels */
  labelSchema?: InputMaybe<Scalars['JSONObject']>;
  marketplace?: InputMaybe<Array<Marketplace>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The platform fee percentage that the company charges. Only SuperAdmins can update this field. */
  platformFee?: InputMaybe<Scalars['Decimal']>;
  tag?: InputMaybe<Scalars['String']>;
  /** Content sections enabled for targeting. Only SuperAdmins can update this field. */
  targetingSections?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateTeaserInput = {
  destinationUrl?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<TeaserFormatType>;
  headline?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['String']>;
  ribbon?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TeaserStatus>;
  targeting?: InputMaybe<TeaserTargetingInput>;
  targetingEpomId?: InputMaybe<Scalars['Int']>;
  targetingEpomIds?: InputMaybe<Array<Scalars['Int']>>;
  teaser?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['ObjectId']>;
  websiteIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type UpdateTrackonomicsIntegrationInput = {
  apiToken?: InputMaybe<Scalars['String']>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
  envCode?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  allowPasswordLogin?: InputMaybe<Scalars['Boolean']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateVevIntegrationInput = {
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  vevSecret: Scalars['String'];
};

export type UpdateWebsiteInput = {
  adsolutelyBoxId?: InputMaybe<Scalars['String']>;
  adsolutelyId?: InputMaybe<Scalars['String']>;
  advertorialSite?: InputMaybe<AdvertorialSiteInput>;
  allowContimoHostedAdvertorials?: InputMaybe<Scalars['Boolean']>;
  allowProviderContentAdvertorials?: InputMaybe<Scalars['Boolean']>;
  allowSelfHostedAdvertorials?: InputMaybe<Scalars['Boolean']>;
  cpcFloorPrice?: InputMaybe<Scalars['Decimal']>;
  cprFloorPrice?: InputMaybe<Scalars['Decimal']>;
  ctaButtonSelector?: InputMaybe<Scalars['String']>;
  enabledOnMarketplace?: InputMaybe<Scalars['Boolean']>;
  /** Company IDs exempt from floor price. Available only for SuperAdmins. */
  floorPriceExemptCompanyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  internalArticleId?: InputMaybe<Scalars['String']>;
  minimumSpend?: InputMaybe<Scalars['Decimal']>;
  monthlyVisitors?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  prohibitMarketplaceDisplay?: InputMaybe<Scalars['Boolean']>;
  rateCard?: InputMaybe<RateCardInput>;
  type?: InputMaybe<WebsiteType>;
  url?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ObjectId'];
  allowPasswordLogin?: Maybe<Scalars['Boolean']>;
  avatarUrl?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  fullname: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  role: UserRole;
  status: UserStatus;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type UserFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  role?: InputMaybe<UserRole>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};

export type UserNotificationSettingsInput = {
  notifications?: InputMaybe<Array<NotificationType>>;
  userId: Scalars['ObjectId'];
};

/** Roles that can be assigned to a user */
export enum UserRole {
  AccountAdmin = 'AccountAdmin',
  Guest = 'Guest',
  RegularUser = 'RegularUser',
  SuperAdmin = 'SuperAdmin'
}

/** User status */
export enum UserStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Invited = 'Invited'
}

export enum V2Migration {
  V1Only = 'V1_ONLY',
  V1Preferred = 'V1_PREFERRED',
  V2Only = 'V2_ONLY',
  V2Preferred = 'V2_PREFERRED'
}

export type VevIntegration = {
  __typename?: 'VevIntegration';
  _id: Scalars['ObjectId'];
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  type: IntegrationType;
  updatedAt: Scalars['DateTime'];
  vevSecret: Scalars['String'];
  webhookId: Scalars['String'];
  webhookUrl: Scalars['String'];
};

export type Video = {
  __typename?: 'Video';
  _id: Scalars['ObjectId'];
  /** Advertiser that this video is associated with */
  advertiserId?: Maybe<Scalars['ObjectId']>;
  /** Company that owns this video */
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  directPlayUrl: Scalars['String'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<VideoStatus>;
  thumbnailUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uploadedBy: Scalars['ObjectId'];
  videoId: Scalars['String'];
};

export type VideoFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  advertiserId?: InputMaybe<Scalars['ObjectId']>;
  /** Overwrite current company id. Available only for SuperAdmins. */
  companyId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<VideoStatus>;
  uploadedBy?: InputMaybe<Scalars['ObjectId']>;
};

export type VideoInfoResponse = {
  __typename?: 'VideoInfoResponse';
  averageWatchTime?: Maybe<Scalars['Int']>;
  dateUploaded: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['String']>;
  isPublic: Scalars['Boolean'];
  length?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  totalWatchTime?: Maybe<Scalars['Int']>;
  videoLibraryId: Scalars['Int'];
  views?: Maybe<Scalars['Int']>;
};

export type VideoPlayDataResponse = {
  __typename?: 'VideoPlayDataResponse';
  originalUrl?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  video: VideoInfoResponse;
  videoPlaylistUrl?: Maybe<Scalars['String']>;
};

/** Video statuses */
export enum VideoStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type Website = {
  __typename?: 'Website';
  _id: Scalars['ObjectId'];
  adsolutelyBoxId?: Maybe<Scalars['String']>;
  adsolutelyId?: Maybe<Scalars['String']>;
  advertorialInternalUrl: Scalars['String'];
  advertorialSite?: Maybe<AdvertorialSite>;
  advertorialUrl: Scalars['String'];
  allowContimoHostedAdvertorials?: Maybe<Scalars['Boolean']>;
  allowProviderContentAdvertorials?: Maybe<Scalars['Boolean']>;
  allowSelfHostedAdvertorials?: Maybe<Scalars['Boolean']>;
  contimoToken: Scalars['String'];
  /** Minimum CPC gross bid price for marketplace campaigns */
  cpcFloorPrice?: Maybe<Scalars['Decimal']>;
  /** Minimum CPR gross bid price for marketplace campaigns */
  cprFloorPrice?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  ctaButtonSelector?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  enabledOnMarketplace?: Maybe<Scalars['Boolean']>;
  epomDefaultZoneId?: Maybe<Scalars['Int']>;
  epomId?: Maybe<Scalars['Int']>;
  /** Company IDs exempt from floor price */
  floorPriceExemptCompanyIds?: Maybe<Array<Scalars['ObjectId']>>;
  internalArticleId?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Array<Marketplace>>;
  minimumSpend?: Maybe<Scalars['Decimal']>;
  monthlyVisitors?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  placements: Array<Placement>;
  prohibitMarketplaceDisplay?: Maybe<Scalars['Boolean']>;
  publisher?: Maybe<Publisher>;
  publisherId: Scalars['ObjectId'];
  rateCard?: Maybe<RateCard>;
  type: WebsiteType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type WebsiteFilterArgs = {
  /** Filter by one or multiple ids. */
  _id?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Overwrite current publisher id. Available only for SuperAdmins. */
  publisherId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<WebsiteType>>;
};

export type WebsitePrice = {
  __typename?: 'WebsitePrice';
  price: Scalars['Decimal'];
  websiteId: Scalars['ObjectId'];
};

export type WebsitePriceInput = {
  price: Scalars['Decimal'];
  websiteId: Scalars['ObjectId'];
};

/** Assign a type to the website */
export enum WebsiteType {
  Blog = 'Blog',
  Entertainment = 'Entertainment',
  Fashion = 'Fashion',
  FoodAndLifestyle = 'Food_and_Lifestyle',
  HomeAndGarden = 'Home_and_Garden',
  News = 'News',
  Science = 'Science',
  Sport = 'Sport',
  Tabloid = 'Tabloid'
}
